export default __webpack_public_path__ + "media/9a95e8c76b35312676d7bf52fa82e3e861d8dcf2272dc5a188fdbbb9c7656f69.svg";